import React, {
  ChangeEventHandler,
  FocusEventHandler,
  forwardRef,
  HTMLInputTypeAttribute,
  ReactNode,
} from "react";
import clsx from "clsx";

import { noop } from "src/lib";

export type InputProps = {
  name?: string;
  placeholder?: string;
  onBlur?: FocusEventHandler;
  onFocus?: FocusEventHandler;
  wrapClassName?: string;
  className?: string;
  onChange: ChangeEventHandler;
  disabled?: boolean;
  value?: string;
  label?: string;
  type?: HTMLInputTypeAttribute;
  isValid?: boolean;
  error?: ReactNode;
  [x: string]: any;
};

export const Input = forwardRef<HTMLInputElement, InputProps>(
  (
    {
      name,
      onChange,
      type,
      value = "",
      disabled = false,
      onFocus = noop,
      onBlur = noop,
      children,
      wrapClassName,
      className,
      label,
      id,
      isValid = true,
      error,
      ...props
    },
    ref
  ) => (
    <>
      <div
        className={clsx(
          "flex flex-col items-start text-white w-full relative",
          wrapClassName
        )}
      >
        {children}

        <input
          className={clsx(
            "peer h-[29px] w-full border-b text-body border-b-neutral-5 text-high-contrast placeholder-transparent focus:outline-none focus:border-b-primary-base disabled:bg-white disabled:text-alarm-not-accepted",
            {
              "border-b-input-error focus:border-b-input-error": Boolean(error),
            },
            className
          )}
          ref={ref}
          name={name}
          onChange={onChange}
          placeholder=" "
          type={type}
          value={value}
          disabled={disabled}
          onFocus={onFocus}
          onBlur={onBlur}
          id={id}
          {...props}
        />

        {label && (
          <label
            className="absolute left-0 -top-3.5 text-light-gray text-[12px] leading-[18px] transition-all peer-placeholder-shown:text-[14px] peer-placeholder-shown:leading-[21px] peer-placeholder-shown:top-1.5 peer-focus:-top-3.5 peer-focus:text-[12px] peer-focus:leading-[18px]"
            htmlFor={id || name}
          >
            {label}
          </label>
        )}
      </div>
      {error && <span className="mt-2 text-sm text-red-500">{error}</span>}
    </>
  )
);

Input.displayName = "Input";
